<script setup>
const benefits = [
  {
    title: 'Enhanced Security',
    text: 'Protect every transaction with advanced encryption, intelligent fraud detection.',
    image: '/benefitsImage/benefits-img1.svg',
    bgImage: '/benefitsImage/benefits-bgImg1.png'
  },
  {
    title: 'Seamless Integration',
    text: 'Connect online store, mobile app, or custom platform through flexible APIs and SDKs.',
    image: '/benefitsImage/benefits-img2.svg',
    bgImage: '/benefitsImage/benefits-bgImg2.png'
  },
  {
    title: 'Cost Efficiency',
    text: 'Save more with low transaction fees, transparent pricing, and fewer chargebacks.',
    image: '/benefitsImage/benefits-img3.svg',
    bgImage: '/benefitsImage/benefits-bgImg3.png'
  },
  {
    title: 'Improved Cash Flow',
    text: 'Accelerate settlements, automate recurring billing, and keep your revenue stream consistent.',
    image: '/benefitsImage/benefits-img4.svg',
    bgImage: '/benefitsImage/benefits-bgImg4.png'
  },
  {
    title: 'Convenience',
    text: 'Offer multiple payment methods and deliver a smooth checkout experience for your customers.',
    image: '/benefitsImage/benefits-img5.svg',
    bgImage: '/benefitsImage/benefits-bgImg5.png'
  },
  {
    title: 'Reliable Support',
    text: 'Get 24/7 expert assistance and fast dispute resolution from our dedicated support team.',
    image: '/benefitsImage/benefits-img6.svg',
    bgImage: '/benefitsImage/benefits-bgImg6.png'
  }
];
</script>

<template>
  <div class="benefits" id="benefits">
    <img src="@icons/big-ball.svg" alt="" class="big" />
    <img src="@icons/small-ball.svg" alt="" class="small" />
    <div class="container">
      <div class="benefits__wrapper">
        <h2>Our Benefits</h2>
        <div class="benefits__wrapper__outer">
          <div class="benefits__wrapper__grid">
            <div v-for="(benefit, i) in benefits" :key="i" class="card" style="width: 384px; height: 240px">
              <img :src="benefit.bgImage" alt="" style="z-index: -1; width: 380px" />
              <img :src="benefit.image" alt="" style="top: 17px; right: 17px" />
              <h3 class="card-title">{{ benefit.title }}</h3>
              <span></span>
              <p class="card-text">{{ benefit.text }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
span {
  width: 100px;
  height: 1px;
  background-color: black;
}

h3 {
  color: #46302e;
  font-family: "Didact Gothic", sans-serif;
  font-size: 22px;
  font-weight: 400;
}

p {
  color: #46302e;
  text-align: justify;
  font-family: "Didact Gothic", sans-serif;
  font-size: 20px;
  font-weight: 400;
}

h2 {
  color: #46302e;
  font-family: "Libre Caslon Text", sans-serif;
  font-size: 36px;
  font-style: italic;
  font-weight: 500;
}

.big {
  position: absolute;
  bottom: 20%;
  left: 50px;
  z-index: 2;
}

.small {
  position: absolute;
  z-index: 100;
  left: 115px;
  bottom: -40px;
}

.benefits {
  margin-top: 80px;
  position: relative;

  &__wrapper {
    position: relative;
    z-index: 10;
    display: flex;
    flex-direction: column;
    gap: 25px;

    &__grid {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      grid-template-rows: repeat(2, 1fr);
      gap: 24px;
      justify-items: center;
    }
  }
}

.card {
  width: 384px;
  height: 240px;
  aspect-ratio: 1.6 / 1;
  padding: 24px;
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  gap: 15px;

  & img {
    position: absolute;
    top: 0;
    right: 0;
    max-width: 100%;
    height: auto;
  }
}

/* ---------- адаптив ---------- */

/* планшеты */
@media (max-width: 1024px) {
  .benefits__wrapper__grid {
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: auto;
    gap: 20px;
  }

  .card {
    aspect-ratio: 1.4 / 1;
    padding: 20px;

    h3 {
      font-size: 20px;
    }

    p {
      font-size: 18px;
    }
  }

  .big {
    left: 20px;
    bottom: 15%;
    width: 80px;
  }

  .small {
    left: 80px;
    bottom: -30px;
    width: 40px;
  }
}

/* мобильные */
@media (max-width: 768px) {
  .benefits__wrapper__grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .benefits h2 {
    font-size: 30px;
    text-align: center;
  }

  .card {
    aspect-ratio: auto;
    padding: 18px;
    align-items: center;
    text-align: center;

    border-radius: 30px;
    background: linear-gradient(102deg, #F5E7CE 1.25%, #F9EFDF 60.04%);


    h3 {
      font-size: 20px;
    }

    p {
      font-size: 16px;
      text-align: center;
      max-width: 90%;
    }

    span {
      margin: 0 auto;
    }

    img[style] {
      display: none;
    }
  }

  .big,
  .small {
    display: none;
  }
}

/* маленькие экраны */
@media (max-width: 480px) {
  .benefits {
    margin-top: 60px;
  }

  .benefits h2 {
    font-size: 26px;
  }

  .card {
    padding: 15px;

    h3 {
      font-size: 18px;
    }

    p {
      font-size: 15px;
    }
  }
}
</style>
